import { Button, InputNumber, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { EllipseIcon } from "../../../../atoms/icon";
import "./credit-spread-table.scss"
import { useState } from "react";

const defaultData = [{
    currency: 'CAD',
    inYears: 0,
    inDays: 0,
    percent: 1.86
},
{
    currency: 'USD',
    inYears: 0,
    inDays: 0,
    percent: 0.59
},
// {
//     currency: 'EUR',
//     inYears: 0,
//     inDays: 0,
//     percent: 0.96
// },
// {
//     currency: 'GBP',
//     inYears: 0,
//     inDays: 0,
//     percent: 1.16
// },
// {
//     currency: 'JPY',
//     inYears: 0,
//     inDays: 0,
//     percent: 2.54
// }
]

const CreditSpreadTable = () => {
    const { t } = useTranslation();
    const [data, setData] = useState(defaultData);

    const updateData = (index: Number, key: string, value: number | null ) => {
        const newData = [...data];
        newData.forEach((element: any, i) => {
            if (i === index) {
                element[key] = value;
            }
        });
        setData(newData);
    }

    return <div className="credit-spread">
        <div className="credit-spread__header">
            <div className="credit-spread__des">
                <Button className='yellow-contained' >
                    <div>{t("FundsTransferPricing.creditSpreads")}</div>
                    <div className='credit-date'> {t("FundsTransferPricing.dataIsFor")} 05/31/2024</div>
                </Button>
            </div>
            <div className="credit-spread__col-wrapper">
                <div className="credit-spread__col-item">
                </div>
                <div className="credit-spread__col-item">
                    {t("FundsTransferPricing.duration")}
                </div>
                <div className="credit-spread__col-item">
                    {t("FundsTransferPricing.orDuration")}
                </div>
                <div className="credit-spread__col-item">
                    {t("FundsTransferPricing.ftpCreditSpread")}
                </div>
            </div>
        </div>
        <div className="credit-spread__body">
            <div className="credit-spread__des">
                Choose <span className="blue-text" >years or days</span> for duration in the <br />
                required currency. No spread is charged <br />
                below <span className="blue-text" >28 days duration</span>. If you have a figure <br /> in both columns, you need to delete one.
            </div>
            <div className="credit-spread__table">
                <div className="credit-spread__table__header">
                    <div className="credit-spread__table__row">
                        <div className="credit-spread__table__cell">
                            {t("FundsTransferPricing.currency")}
                        </div>
                        <div className="credit-spread__table__cell">
                            {t("FundsTransferPricing.inYears")}
                        </div>
                        <div className="credit-spread__table__cell">
                            {t("FundsTransferPricing.inDays")}
                        </div>
                        <div className="credit-spread__table__cell">
                            %
                        </div>
                    </div>
                </div>
                <div className="credit-spread__table__body">
                    {
                        data.map((item, i) =>
                            <div className="credit-spread__table__row" key={i}>
                                <div className="credit-spread__table__cell">
                                    {item.currency}
                                </div>
                                <div className="credit-spread__table__cell">
                                    <InputNumber onChange={(value) => updateData(i, "inYears", value)} defaultValue={item.inYears} />
                                </div>
                                <div className="credit-spread__table__cell">
                                    <InputNumber onChange={(value) => updateData(i, "inDays", value)} defaultValue={item.inDays} />
                                </div>
                                <div className="credit-spread__table__cell">
                                    <span className="credit-spread__table__percent">
                                        <div className="credit-spread__table__dot">
                                        </div>
                                        <Tag className='percent-tag' icon={<EllipseIcon className='ellipse' />} >
                                            {(item.inYears !== 0 && item.inYears) || (item.inDays !== 0 && item.inDays) ? item.percent : "0.00"}
                                        </Tag>
                                    </span>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    </div>
}

export default CreditSpreadTable;